export default "__VITE_ASSET__dbe1c33b__"